import React, { useState, useRef, useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";

const HAFHQRScanner = ({ onScan, fallbackOnly = false }) => {
  const [scanning, setScanning] = useState(false);
  const [result, setResult] = useState("");
  const scannerRef = useRef(null);

  useEffect(() => {
    if (scanning && !fallbackOnly) {
      const scanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 250 }, false);
      scannerRef.current = scanner;

      scanner.render(
        (decodedText) => {
          setResult(decodedText);
          onScan?.(decodedText);
          scanner.clear();
          setScanning(false);
        },
        (error) => console.warn("QR Scan error:", error)
      );

      return () => scanner.clear();
    }
  }, [scanning, fallbackOnly]);

  return (
    <div className="bg-gray-800 rounded-xl p-5">
      {/* <h3 className="text-yellow-300 font-semibold mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faQrcode} /> Compulsory QR Attendance
      </h3> */}

      {!fallbackOnly && (
        <button
          onClick={() => setScanning(!scanning)}
          className="w-40 lg:w-48 text-xs lg:text-sm py-2 bg-teal-600 hover:bg-teal-700 rounded-xl mb-4 font-medium"
        >
          {scanning ? "Stop Scanning" : "Start QR Scanner"}
        </button>
      )}

      {scanning && !fallbackOnly && <div id="qr-reader" className="mb-4" />}

      {/* Demo Fallback Button (always available) */}
      <button
        onClick={() => {
          const demoResult = "COMPULSORY_IN_2026-05-01_12:SRISHTI_HOSTELS";
          setResult(demoResult);
          onScan?.(demoResult);
          alert("Demo QR Scanned Successfully!\n" + demoResult);
        }}
        className="w-64 text-xs lg:text-sm py-2 bg-gray-700 hover:bg-gray-600 rounded-xl"
      >
        Demo: Simulate QR Scan (IN)
      </button>

      {result && <p className="mt-4 text-emerald-400 text-xs break-all">Scanned: {result}</p>}
    </div>
  );
};

export default HAFHQRScanner;